import React from "react";
import DNASankey from "./DNASankey";

const DNASankeyPage: React.FC = () => {
  return (
    <section className="genealogy-section">
      <h1 className="heading-1">DNA Flow</h1>
      <DNASankey />
    </section>
  );
};

export default DNASankeyPage; 